import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0A1628] text-white">
      <div className="max-w-[1400px] mx-auto px-8 py-20">
        <div className="grid grid-cols-4 gap-12 mb-16">
          <div>
            <div className="text-3xl font-bold mb-4">UnityCore</div>
            <p className="text-gray-400 font-light leading-relaxed mb-6">
              Международная финансовая и управленческая экспертиза с 2010 года
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full border border-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-[#D4AF37] hover:text-[#0A1628]"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] transition-all cursor-pointer">
                <i className="ri-instagram-line text-[#D4AF37] hover:text-[#0A1628]"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] transition-all cursor-pointer">
                <i className="ri-whatsapp-line text-[#D4AF37] hover:text-[#0A1628]"></i>
              </a>
            </div>
          </div>

          <div>
            <div className="text-[#D4AF37] text-xs tracking-[3px] uppercase mb-6">INSIGHTS</div>
            <div className="relative">
              <input 
                type="email" 
                placeholder="Ваш email"
                className="w-full bg-transparent border-b border-white/30 pb-3 pr-10 text-white placeholder-gray-500 focus:border-[#D4AF37] outline-none transition-colors"
              />
              <button className="absolute right-0 bottom-3 text-[#D4AF37] hover:text-white transition-colors cursor-pointer">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-3">Эксклюзивная аналитика рынков</p>
          </div>

          <div>
            <div className="text-[#D4AF37] text-xs tracking-[3px] uppercase mb-6">НАВИГАЦИЯ</div>
            <ul className="space-y-3">
              <li><Link to="/" className="text-white hover:text-[#D4AF37] transition-colors font-light cursor-pointer">О нас</Link></li>
              <li><Link to="/financial-consulting" className="text-white hover:text-[#D4AF37] transition-colors font-light cursor-pointer">Финансы</Link></li>
              <li><Link to="/management-consulting" className="text-white hover:text-[#D4AF37] transition-colors font-light cursor-pointer">Управление</Link></li>
              <li><Link to="/geography" className="text-white hover:text-[#D4AF37] transition-colors font-light cursor-pointer">География</Link></li>
              <li><Link to="/contacts" className="text-white hover:text-[#D4AF37] transition-colors font-light cursor-pointer">Контакты</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-[#D4AF37] text-xs tracking-[3px] uppercase mb-6">СВЯЗЬ</div>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-[#D4AF37] mt-1"></i>
                <span className="font-light">+90 212 XXX XX XX</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-[#D4AF37] mt-1"></i>
                <span className="font-light">info@unitycore.com</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#D4AF37] mt-1"></i>
                <span className="font-light">Istanbul, Turkey</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="relative bg-[#050D18] py-12 overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-[180px] font-extrabold text-[#F5F7FA]/5 uppercase tracking-wider" style={{ WebkitTextStroke: '2px rgba(245,247,250,0.05)' }}>
            UNITYCORE
          </div>
        </div>
        <div className="relative text-center">
          <p className="text-xs text-gray-600">© 2025 UnityCore Group LLC. Все права защищены.</p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-600 hover:text-[#D4AF37] transition-colors mt-2 inline-block cursor-pointer">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
